var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icons from '../../../icons';
import { CheckboxWrapper, CustomCheckbox, Check } from "./checkbox.styles";
export default function CheckBox(props) {
    var children = props.children, disabled = props.disabled, isChecked = props.isChecked, setIsChecked = props.setIsChecked;
    var handleCheckboxChange = function () {
        if (!disabled) {
            setIsChecked(!isChecked);
        }
    };
    return (_jsxs(CheckboxWrapper, { children: [_jsxs(CustomCheckbox, { children: [_jsx("input", { checked: isChecked, disabled: disabled, type: 'checkbox', onChange: handleCheckboxChange }), _jsx("span", {}), _jsx(Check, { children: isChecked ? _jsx("img", { src: Icons.check, alt: 'check' }) : _jsx("img", { src: Icons.box, alt: 'box' }) })] }), _jsx("div", __assign({ style: { marginLeft: '5px' } }, { children: children }))] }));
}
